'use client';
import styled from 'styled-components';

import { PatchedLink } from '@utils/patched-link';

export const Wrapper = styled.div``;

export const FooterLink = styled(PatchedLink)`
  display: block;
  color: ${({ theme }) => theme.palette.grey1100};
  white-space: nowrap;
  font-size: 12px;
  text-decoration: none;
  line-height: 24px;
  font-weight: 500;
  opacity: 0.5;

  &:hover {
    transition: all 0.3s ease-in-out;
    color: ${({ theme }) => theme.palette.grey1100};
    opacity: 1;
  }
`;

export const Heading = styled.p`
  color: ${({ theme }) => theme.palette.grey1100};
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  word-wrap: break-word;
  margin-bottom: 16px;
`;

export const CategoryGrid = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
  }
`;

export const Category = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
`;
